const $ = require("jquery");
require("waypoints/lib/jquery.waypoints");
require("waypoints/lib/shortcuts/sticky");

export const VError = {
    /**
     * Init handler.
     */
    init: function () {
        new Waypoint.Sticky({
            element: $('.error-handler'),
            wrapper: false
        });
    },

    /**
     * Display generic error handler.
     */
    handle: function () {
        const errorHandler = $('.error-handler');

        if (errorHandler.hasClass('hidden')) {
            errorHandler.transition({
                animation: 'fade in',
                duration: '600ms',
                onComplete: function () {
                    setTimeout(function () {
                        errorHandler.transition('fade out', '600ms');
                    }, 6000);
                }
            });
        }
    }
};

export default VError;